import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuillEditorComponent } from 'ngx-quill';
import { ToastrService } from 'ngx-toastr';
import { FeatureGroups } from 'src/app/models/school/schooladminitem.model';
import { SchoolPackageViewTile } from 'src/app/models/schoolpackageviewtile.model';
import { Settings } from 'src/app/models/settings.model';
import { SchoolPackageService } from 'src/app/services/school-package.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-module-package-editor',
  templateUrl: './module-package-editor.component.html',
  styleUrls: ['./module-package-editor.component.css']
})
export class ModulePackageEditorComponent implements OnInit, AfterViewInit, OnDestroy {

  package: SchoolPackageViewTile = new SchoolPackageViewTile();
  logofilelist: FileList;
  quill: any = {};
  @ViewChild('logoimg') logoimg: ElementRef;
  @ViewChild('description') editor:QuillEditorComponent;
  @ViewChild('price') priceControl: ElementRef;
  destroyed: boolean = false;
  
  constructor(private settings: Settings, private activatedroute: ActivatedRoute, private schoolpackageservice: SchoolPackageService, private toastr: ToastrService, private router: Router, private utilservice: UtilService) { }

  async ngOnInit() {
    const packageId = this.activatedroute.snapshot.queryParams.packageId;

    if(packageId){
      this.package = await this.schoolpackageservice.getSchoolPackage(packageId).toPromise();
    }
    else{
      this.package = new SchoolPackageViewTile();
    }

    if (this.package.imageUrl) {
      this.logoimg.nativeElement.style.display = 'initial';
    }

    if(this.package.description){
      const setQuillDataFunction = () => {
        if(this.quill && this.quill.root){
          this.quill.root.innerHTML = this.package.description;
        }
        else{
          if(!this.destroyed){
            setTimeout(setQuillDataFunction, 100);
          }
        }
      };
      setQuillDataFunction();
    }
  }

  ngOnDestroy(){
    this.destroyed = false;
  }

  ngAfterViewInit(): void {
    //debugger;
    const mythis = this;
    this.editor.onEditorCreated.subscribe(() => {
      this.quill = this.editor.quillEditor;
    });
    this.editor.onEditorChanged.subscribe(() => {
      this.quill = this.editor.quillEditor;
    });
  }

  handleLogoFileChange(files: FileList) {
    if (files.length > 0) {
      this.logofilelist = files;
      this.logoimg.nativeElement.src = URL.createObjectURL(files[0]);
      this.logoimg.nativeElement.style.display = 'initial';
      return;
    }

    if (this.package.imageUrl) {
      this.logoimg.nativeElement.src = this.package.imageUrl;
    } else {
      this.logoimg.nativeElement.style.display = 'none';
    }
  }

  async createupdatepackage() {
    //debugger;
    // if (this.logofilelist && this.logofilelist.length > 0 && !this.handleLogoImageLoaded()) {
    //   return;
    // }
    //debugger;
    this.package.description=this.quill.root.innerHTML;

    if (this.package.description.length > 65535) {
      this.toastr.error('Description too large');
      return;
    }
    if(parseFloat(this.priceControl.nativeElement.value) > 0 && !await this.utilservice.hasFeature(FeatureGroups.E_COMMERCE)){
      this.toastr.error(`The e-commerce feature is required to charge for packages. Please upgrade your account to use charge for courses`);
      return;
    }
    const data = await this.schoolpackageservice.createPackage(this.package).toPromise();
    const packageid = data.id;
    if (this.logofilelist && this.logofilelist.length > 0) {
      await this.schoolpackageservice.uploadPackageLogo(packageid, this.logofilelist[0]).toPromise();
    }
    this.toastr.success('Package saved');
    this.router.navigate(['/user/packagedetails'], { queryParams: { packageId: packageid } });//.then(()=>{window.location.reload(true)});
  }

}
